// Module
var code = "<ws-content-block-reference-item s-item=\"::item\" s-color=\"::ctrl.sColor\" ng-repeat=\"item in ::ctrl.sItem.children\" s-reference-type=\"ctrl.referenceTypes[item.href]\"></ws-content-block-reference-item>";
// Exports
module.exports = code;